export class CenterDto{
    public id: number;
    public name: string;
    public address_1: string;
    public address_2?: string;
    public postal_code: string;
    public country_iso: string;
    public web: string;
    public facebook: string;
    public vat: string;
    public slogan: string;
    public image: string;
}
